import { render, staticRenderFns } from "./NewsVideo.vue?vue&type=template&id=651e853c&scoped=true"
import script from "./NewsVideo.vue?vue&type=script&lang=js"
export * from "./NewsVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e853c",
  null
  
)

export default component.exports